import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { isCurrentActiveFilter, isGenderOrAgeFilter } from '@common/Filters/components/FiltersList/helpers';
import { setOverlay } from '@common/Listing/actions/listingActions';

export const useFiltersList = () => {
    const dispatch = useDispatch();
    const [activeFilter, setActiveFilter] = useState(null);

    const handleHideFilters = () => {
        setActiveFilter(null);
        dispatch(setOverlay(false));
    };

    const handleFilterClick = (filter) => {
        const { type } = filter;

        if (isCurrentActiveFilter(activeFilter, type)) {
            handleHideFilters();
            return;
        }

        if (!isGenderOrAgeFilter(type)) {
            setActiveFilter(filter);
            dispatch(setOverlay(true));
        }
    };

    return {
        activeFilter,
        handleHideFilters,
        handleFilterClick
    };
};
